import { Plus, Maximize2 } from "lucide-react";
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { DeclarationDocumentsTableContent } from './DeclarationDocumentsTableContent';
import { DocumentsTableModal } from './DocumentsTableModal';
import { setLastEditedDocumentField } from '../../../store/reducers/index';
import { getDeclarationSummaryTranslation } from '../../../hooks/useLanguage';

export const DeclarationDocumentsTable = ({
  declarationIndex,
  isSpanish,
  declaration,
  editableData,
  setEditableData,
  setIsDirty,
}) => {
  const [openDocModalIndex, setOpenDocModalIndex] = useState(null);
  const [openTipoModal, setOpenTipoModal] = useState({});
  const [isExpandModalOpen, setIsExpandModalOpen] = useState(false);
  const dispatch = useDispatch();
  const company = useSelector((state) => state.company);
  const userData = useSelector((state) => state.user.userData);
  const companyName = company?.nombre?.toLowerCase() || userData?.first_name?.toLowerCase();

  // Handler for adding Y025 document for TuDeFrigo
  const handleAddY025TuDeFrigo = () => {
    const updatedData = [...editableData];
    if (!updatedData[declarationIndex].documentos)
      updatedData[declarationIndex].documentos = [];
    updatedData[declarationIndex].documentos.push({
      codigo_documento: 'Y025',
      tipo: 1,
      numero: 'ESAEOF240000022A',
      fecha: '2025-10-30',
    });
    setEditableData(updatedData);
    setIsDirty(true);
    dispatch(setLastEditedDocumentField({
      field: '__declaration_documents__',
      value: null,
      declarationIndex,
      partidaIndex: null, // null for declaration-level
      documentIndex: updatedData[declarationIndex].documentos.length - 1,
    }));
  };

  // Handler for adding Y025 document for El Mosca
  const handleAddY025ElMosca = () => {
    const updatedData = [...editableData];
    if (!updatedData[declarationIndex].documentos)
      updatedData[declarationIndex].documentos = [];
    updatedData[declarationIndex].documentos.push({
      codigo_documento: 'Y025',
      tipo: 1,
      numero: 'ESAEOF240000022A',
      fecha: '2025-10-30',
    });
    setEditableData(updatedData);
    setIsDirty(true);
    dispatch(setLastEditedDocumentField({
      field: '__declaration_documents__',
      value: null,
      declarationIndex,
      partidaIndex: null,
      documentIndex: updatedData[declarationIndex].documentos.length - 1,
    }));
  };

  if (!declaration.documentos || !Array.isArray(declaration.documentos) || declaration.documentos.length === 0) {
    return null;
  }

  return (
    <div className="document-table mt-6 ">
      <div className="form-group flex-1 mt-12 !mb-0 flex justify-between flex-row items-center">
        <label htmlFor="companyName" className="!mb-0 !text-sm !opacity-100 !text-xl font-semibold uppercase">
          {!isSpanish ? "Export Level Documents" : "Documentos Nivel Exportación"} (
          {declaration.documentos?.length || 0})
        </label>
        <div className="flex gap-2 items-center">
          {/* Default add document button */}
          <button
            className="py-1 text-xs flex items-center gap-1"
            onClick={() => {
              const updatedData = [...editableData];
              if (!updatedData[declarationIndex].documentos)
                updatedData[declarationIndex].documentos = [];
              updatedData[declarationIndex].documentos.push({
                codigo_documento: "",
                tipo: "",
                numero: "",
                fecha: "",
              });
              setEditableData(updatedData);
              setIsDirty(true);
              dispatch(setLastEditedDocumentField({
                field: '__declaration_documents__',
                value: null,
                declarationIndex,
                partidaIndex: null,
                documentIndex: updatedData[declarationIndex].documentos.length - 1,
              }));
            }}
          >
            <Plus className={`size-4`} />
            {isSpanish ? "Agregar Documento" : "Add Document"}
          </button>
          {/* Client-specific Y025 buttons */}
          {companyName === 'tudefrigo' && (
            <button
              className="py-1.5 text-xs flex items-center gap-1 bg-secondary rounded-full pl-2 pr-3"
              onClick={handleAddY025TuDeFrigo}
              type="button"
            >
              <Plus className="size-4" />
              Agregar Y025
            </button>
          )}
          {companyName === 'el mosca' && (
            <button
              className="py-1.5 text-xs flex items-center gap-1 bg-secondary rounded-full pl-2 pr-3"
              onClick={handleAddY025ElMosca}
              type="button"
            >
              <Plus className="size-4" />
              Agregar Y025
            </button>
          )}
          {/* Expand View button */}
          <button
            className="bg-default text-white rounded-full py-1.5 px-3 text-xs flex items-center gap-1"
            onClick={() => setIsExpandModalOpen(true)}
            title={!isSpanish ? "Expand View" : "Vista Expandida"}
          >
            <Maximize2 className="size-3 stroke-white" />
            {!isSpanish ? "Expand View" : "Vista Expandida"}
          </button>
        </div>
      </div>
      <DeclarationDocumentsTableContent
        declarationIndex={declarationIndex}
        isSpanish={isSpanish}
        declaration={declaration}
        editableData={editableData}
        setEditableData={setEditableData}
        setIsDirty={setIsDirty}
        openDocModalIndex={openDocModalIndex}
        setOpenDocModalIndex={setOpenDocModalIndex}
        openTipoModal={openTipoModal}
        setOpenTipoModal={setOpenTipoModal}
      />
      {/* Note: DocumentsTableModal can be reused but needs to handle declaration-level */}
    </div>
  );
};

